/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiPrice
 */
export interface ApiPrice {
    /**
     * 
     * @type {number}
     * @memberof ApiPrice
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ApiPrice
     */
    currencyCode: string;
}

export function ApiPriceFromJSON(json: any): ApiPrice {
    return ApiPriceFromJSONTyped(json, false);
}

export function ApiPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currencyCode': json['currencyCode'],
    };
}

export function ApiPriceToJSON(value?: ApiPrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'currencyCode': value.currencyCode,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
